import { createFileRoute } from "@tanstack/react-router";
import VaCcnInsurance, { config } from "@/pages/VaCcnInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/va-ccn-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "VA Community Care Network (CCN) TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "VA Community Care Network coverage for TMS, SAINT TMS, and SPRAVATO. Learn about veteran benefits and verification in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content:
            "VA Community Care Network (CCN) TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "VA Community Care Network coverage for TMS, SAINT TMS, and SPRAVATO. Learn about veteran benefits and verification in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/va-ccn-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/va-ccn-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <VaCcnInsurance />;
}
